import React, { useRef, useState } from 'react'

import PropTypes from 'prop-types'
import { PlusCircle as PlusCircleIcon, Send as SendIcon } from 'react-feather'
import { isEmpty } from 'lodash'
import { Button, Tooltip } from '@material-ui/core'

import { SendPlanActionsModal } from './components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

const PlanActionsHeaderButton = ({
  evidencePlanActions = [],
  setEvidencePlanActions,
}) => {
  const [openSendModal, setOpenSendModal] = useState(false)

  const { isShow } = useThirdPartyManagementStepper()

  const draftCounter = useRef(0)

  const hasUnsavedDraft = evidencePlanActions.some((item) => !item.id)

  const handleAddDraft = () =>
    setEvidencePlanActions((current) => {
      if (current.some((item) => !item.id)) return current
      draftCounter.current += 1
      return [
        ...current,
        {
          id: null,
          draftKey: draftCounter.current,
          evidence: {},
          planActions: [{}],
        },
      ]
    })

  if (isShow) {
    return (
      <>
        <Tooltip
          title={
            isEmpty(evidencePlanActions)
              ? 'Não há planos de ação para enviar'
              : ''
          }
        >
          {/* Span para Tooltip aparecer no botão desabilitado */}
          <span>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SendIcon size={18} />}
              onClick={() => setOpenSendModal(true)}
              disabled={isEmpty(evidencePlanActions)}
            >
              Enviar Planos de ação ao fornecedor
            </Button>
          </span>
        </Tooltip>

        {openSendModal && (
          <SendPlanActionsModal
            open={openSendModal}
            setOpen={setOpenSendModal}
            evidencePlanActions={evidencePlanActions}
          />
        )}
      </>
    )
  }

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<PlusCircleIcon size={18} />}
      onClick={handleAddDraft}
      disabled={hasUnsavedDraft}
    >
      Adicionar plano de ação
    </Button>
  )
}

PlanActionsHeaderButton.propTypes = {
  evidencePlanActions: PropTypes.array,
  setEvidencePlanActions: PropTypes.func.isRequired,
}

export default PlanActionsHeaderButton
